import { TagInterface } from 'riot';
import cadastreReportStore from '../../stores/cadastreReport';
import * as cadastreReportConstants from '../../constants/cadastreReport';

const { events: cadastreReportEvents } = cadastreReportConstants;

export interface CadastreReportTag extends TagInterface {
  loading: boolean;
}

export const init = (tag: CadastreReportTag): void => {
  const onCadastreLookupLoading = (): void => {
    tag.loading = true;
    tag.update();
  };

  const onCadastreLookupLoaded = (): void => {
    tag.loading = false;
    tag.update();
  };

  tag.on('mount', () => {
    cadastreReportStore.on(cadastreReportEvents.CADASTRE_LOOKUP_LOADING, onCadastreLookupLoading);
    cadastreReportStore.on(cadastreReportEvents.CADASTRE_LOOKUP_LOADED, onCadastreLookupLoaded);
  });

  tag.on('unmount', () => {
    cadastreReportStore.off(cadastreReportEvents.CADASTRE_LOOKUP_LOADING, onCadastreLookupLoading);
    cadastreReportStore.off(cadastreReportEvents.CADASTRE_LOOKUP_LOADED, onCadastreLookupLoaded);
  });
};
